import React from 'react';
import dynamic from 'next/dynamic';
import { createGlobalStyle } from 'styled-components';

import reduxWrapper from '@src/store';
import { execDefaultServerSideProps } from '@src/router/ssr';

const GlobalStyle = createGlobalStyle`
	#footer, #header, #mobile-header {
		display: none !important;
	}
`;

const HRPage = dynamic(() => import('@src/components/hr'), {
	ssr: false,
});

const HR = (): JSX.Element => (
	<>
		<GlobalStyle />
		<HRPage />
	</>
);

export const getServerSideProps = reduxWrapper.getServerSideProps(
	async ctx => {
		await execDefaultServerSideProps(ctx);
	},
);

export default HR;
